export const normalizeForComparison = (obj: any): any => {
  if (!obj) return obj
  const normalized = JSON.parse(JSON.stringify(obj))
  const cleanObject = (o: any): any => {
    if (typeof o !== 'object' || o === null) return o
    const cleaned: any = Array.isArray(o) ? [] : {}
    for (const key in o) {
      const val = o[key]
      if (val === undefined || val === '' || val === null) {
        continue
      }
      if (typeof val === 'object') {
        const cleanedVal = cleanObject(val)
        if (Object.keys(cleanedVal).length > 0 || Array.isArray(cleanedVal)) {
          cleaned[key] = cleanedVal
        }
      } else {
        cleaned[key] = val
      }
    }
    return cleaned
  }
  return cleanObject(normalized)
}
